import EllipsisOutlined from '@ant-design/icons/EllipsisOutlined'
import Toggle from 'components/Toggle'
import React, {cloneElement, useContext} from 'react'
import {NullAsDefault} from 'views/Shared'
import {LayoutContext} from '../layouts/Default/LayoutContext'
import DrawerBottomMenu from './DrawerBottomMenu'
import DropDownMenu from './DropDownMenu'
import {Menu} from "antd";

export const DrawMenu = ({
                             component = <EllipsisOutlined/>,
                             container = 'root',
                             menu,
                             open,
                             menuPlacement = 'bottomRight',
                             onCancel = NullAsDefault,
                             ...props
                         }) => {
    const {isSm} = useContext(LayoutContext)

    return isSm ? (
        <Toggle defaultValue={open}>
            {(isToggle, toggle) => {
                return (
                    <>
                        {cloneElement(component, {
                            ...component.props,
                            onClick: toggle,
                        })}
                        {!!isToggle && (
                            <DrawerBottomMenu
                                {...{
                                    isToggle,
                                }}
                                toggle={(value) => {
                                    toggle(value)
                                    onCancel()
                                }}
                                component={component}>
                                <Menu
                                    onClick={({key}) => {
                                        menu.onClick({key})
                                        toggle()
                                    }}
                                    items={menu.items}
                                />
                            </DrawerBottomMenu>
                        )}
                    </>
                )
            }}
        </Toggle>
    ) : (
        <DropDownMenu
            {...props}
            open={open}
            menu={menu}
            container={container}
            component={component}
            placement={menuPlacement}>
        </DropDownMenu>
    )
}

export default DrawMenu
